import React from "react";
import { Grow, Box, Typography, IconButton } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import CloseIcon from "@mui/icons-material/Close";

const QRCodeDialog = ({
  open = false,
  qrStrings = [],
  infoString = "",
  onClose,
}) => {
  // qrStrings is now an array of objects: [{ id, name }, ...]
  const parsedQrCodes = React.useMemo(() => {
    if (!qrStrings || qrStrings.length === 0) return [];

    // Handle both old format (strings) and new format (objects)
    return qrStrings.map((item) => {
      if (typeof item === "object" && item.id) {
        return { id: item.id, name: item.name || "打擊區" };
      }
      // Fallback for string format
      return { id: String(item), name: "打擊區" };
    });
  }, [qrStrings]);

  return (
    open && (
      <Grow in={open} style={{ transformOrigin: "50% 100% 0" }} timeout={500}>
        <Box
          border={3}
          borderColor="#02a4e3"
          padding={3}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          position="fixed"
          width="80vw"
          maxWidth={parsedQrCodes.length > 1 ? 600 : 360}
          top="50%"
          left="50%"
          style={{
            transform: "translate(-50%, -50%)",
          }}
          bgcolor="#ffffffff"
          borderRadius={5}
          zIndex={1500}
          maxHeight="80vh"
          overflow="auto"
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: "#fff",
              bgcolor: "#02a4e3",
              "&:hover": {
                bgcolor: "#0190be",
              },
            }}
            size="large"
          >
            <CloseIcon />
          </IconButton>
          <Typography
            mt={4}
            mb={2}
            fontSize="20pt"
            fontWeight="bold"
            color="#000000"
          >
            {infoString}
          </Typography>
          {parsedQrCodes.length === 0 ? (
            <Typography
              fontSize="16pt"
              color="#666"
              sx={{
                textAlign: "center",
                py: 4,
              }}
            >
              入場碼於入場前10分鐘顯示
            </Typography>
          ) : (
            <Box display="flex" flexWrap="wrap" justifyContent="center" gap={2}>
              {parsedQrCodes.map((item) => (
                <Box
                  key={item.id}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  m={1}
                >
                  <Box
                    sx={{
                      bgcolor: "#fff",
                      borderRadius: 4,
                      boxShadow: "0 0 16px #02a4e3aa",
                      p: 1,
                    }}
                  >
                    <QRCodeSVG value={item.id} size={142} />
                  </Box>
                  <Typography
                    mt={2}
                    fontSize="14pt"
                    color="#333"
                    sx={{
                      fontWeight: "bold",
                      letterSpacing: 0.5,
                      textAlign: "center",
                    }}
                  >
                    {item.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Grow>
    )
  );
};

export default QRCodeDialog;
